import { AlertCircle, RefreshCcw } from "lucide-react";
import type { FC } from "react";

import { CustomButton } from "@/components/atoms";

import type { ErrorConfigType } from "../MenuUploader/TabsMenuConnector";

interface Props {
  cfg: ErrorConfigType;
}

const ErrorBlock: FC<Props> = ({ cfg }) => {
  return (
    <div className="py-16 border border-red-200 rounded-2xl bg-red-50/40 flex items-center justify-center">
      <div className="flex flex-col items-center justify-center max-w-[50%] text-center gap-4">
        <div className="p-3 rounded-full bg-red-100">
          <AlertCircle className="w-6 h-6 text-red-600" />
        </div>
        <div>
          <h3 className="text-lg font-bold mb-1">{cfg.title}</h3>
          <p className="text-sm text-gray-500">{cfg.description}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 mt-2">
          {cfg.actions.map(action => (
            <CustomButton
              key={action.label}
              type="button"
              variant={action.variant ?? "default"}
              onClick={action.handler}
              className={action.label === "Retry" ? "gap-2" : undefined}
            >
              {action.label === "Retry" && <RefreshCcw className="w-4 h-4" />}
              {action.label}
            </CustomButton>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ErrorBlock;
